import { useEffect, useState } from "react"

import { ContentTag, Obj, load } from "scrivito"
import { DemandRequestOverlayObj } from "scrivito/Objs/DemandRequestOverlay/DemandRequestOverlayObjClass"
import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { getCurrentSiteID } from "shared/lib/getCurrentSiteID"

export function useDemandRequestOverlayModel() {
  const { closeOverlay } = useCurrentOverlay()
  const [isLoading, setIsLoading] = useState(true)
  const [demandRequestOverlayObj, setDemandRequestOverlayObj] =
    useState<DemandRequestOverlayObj | null>(null)

  useEffect(() => {
    if (!demandRequestOverlayObj) {
      setIsLoading(true)
      load(() =>
        Obj.onSite(getCurrentSiteID())
          .where("_objClass", "equals", "DemandRequestOverlay")
          .first()
      ).then(obj => {
        setDemandRequestOverlayObj((obj as DemandRequestOverlayObj) ?? null)
        setIsLoading(false)
      })
    } else {
      setIsLoading(false)
    }
  }, [])

  return {
    form: demandRequestOverlayObj ? (
      <ContentTag
        attribute="form"
        content={demandRequestOverlayObj}
        className="demand-request-overlay__form"
      />
    ) : null,
    isLoading,
    closeOverlay
  }
}
